import { createPermission } from "@backstage/plugin-permission-common";

export const compensationForgeAccessPermission = createPermission({
  name: "compensation-forge.access",
  attributes: {
    action: "read",
  },
});

export const compensationForgeLTAccessPermission = createPermission({
  name: "compensation-forge.access.lt",
  attributes: {
    action: "read",
  },
});
